export const LEFT_NAV_WIDTH = 48;
